import { Link } from "react-router-dom";
import { Clapperboard } from "lucide-react";

export const SeeItInAction = ({ chapter, className = "" }) => (
  <Link to={`/demo/features?c=${chapter}`} title="Watch this feature in the product demo"
    className={`inline-flex items-center gap-1.5 text-xs font-semibold text-primary hover:underline underline-offset-4 whitespace-nowrap ${className}`}
    data-testid={`see-it-in-action-${chapter}`}>
    <Clapperboard className="h-3.5 w-3.5" /> See it in action
  </Link>
);
